// extracted by mini-css-extract-plugin
export default {"formNameBox":"index_formNameBox_ewNPv","formName":"index_formName_Z01I5","formWarning":"index_formWarning_i3GXQ","formNameStart":"index_formNameStart_DhrOQ"};